<nz-divider></nz-divider>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="lpcoApprovalGroup">

  <div nz-row>
  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="mr-md">
      <nz-form-label nzRequired>LPCO Approval status</nz-form-label>
      <nz-form-control [nzErrorTip]="'LPCO Approval Status is Required'">
        <nz-select required nzPlaceHolder="LPCO Status" formControlName="lpcoStatus" id="lpcoStatustype" (ngModelChange)="lpcoStatusChange($event)">
          <nz-option *ngFor="let is of lpcoStatusList" [nzValue]="is.code" [nzLabel]="is.description"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="showrejectionReason">
    <nz-form-item class="ml-lg">
      <nz-form-label nzRequired> Rejection Reason
        <span nz-tooltip nzTitle="Rejection Reason">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Rejection Reason is Required'">
        <nz-select required [nzPlaceHolder]="'Rejection Reason'" formControlName="rejectionReason" id="rejectionReasontype">
          <nz-option *ngFor="let fa of rejectionReasonList" [nzLabel]="fa.description" [nzValue]="fa.code"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>



  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <nz-form-item class="mr-md">
      <nz-form-label nzRequired> Remarks
        <span nz-tooltip nzTitle="Remarks">
          <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
        </span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="'Remarks is Required'">
        <textarea required rows="2" formControlName="remarks" id="remarkstype" nz-input></textarea>
      </nz-form-control>
    </nz-form-item>
  </div>

  <div nz-col nzXl="24" nzLg="24"nzMd="24" nzSm="24" nzXs="24">
    <div class="float-right">
      <button nz-button id="onSubmit" (click)="onSubmit()">Submit</button>
    </div>
  </div>

</div>
</form>
